import { render } from "./EmployeesOnLeaveWidget.vue?vue&type=template&id=c1c9ee5e&scoped=true"
import script from "./EmployeesOnLeaveWidget.vue?vue&type=script&lang=js"
export * from "./EmployeesOnLeaveWidget.vue?vue&type=script&lang=js"

import "./employee-on-leave-widget.scss?vue&type=style&index=0&id=c1c9ee5e&lang=scss&scoped=true"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c9ee5e"]])

export default __exports__